export class CommonService {
  // 测数字，最多两位小数
  static numReg = /^([1-9]\d*|0)(\.\d{1,2})?$/;
  static integerReg = /^[1-9]\d*$/;
  // element检测金额（最多两位小数）
  static validatorAmount(value, callback, tip) {
    if (!this.numReg.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  }
  // element检测正整数
  static validatorInteger(value, callback, tip) {
    if (!this.integerReg.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  }
}
